import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserService } from '../../../../_Common/_Services/user.service'; 
import { GlobalSettingsService } from '../../../../_Common/_Services/global-settings.service'; 
import { catchError } from 'rxjs/operators';
import moment from 'moment';
import { DexieService } from '../../../../services/dexie/dexie.service'; 
@Injectable()
export class MPhoneService {

    constructor(
        private http: HttpClient,
        private userService: UserService,
        private globalSettings: GlobalSettingsService,
        private dexieService: DexieService
    ) { }

    getResponseTypes(dueId: any): Observable<any> {
        return this.http.get(`${this.globalSettings.getApiUrl()}/api/communicationManager/showCustomerResponseTemplates/phone/?dueId=` + dueId)
            .pipe(
                catchError((e: any) => this.userService.getCheckError(e)));
    }


    saveCommunicationDetail(postBody: any, file?: any): Promise<any> {
        const endPoint = `${this.globalSettings.getApiUrl()}/api/communicationManager/communicationDetailPhoneLog`;
        const formData: FormData = new FormData();
        if (file) {
            formData.append("file", file, file.name);
        }
        // if the user is offline 
        formData.append("phoneData", JSON.stringify(postBody));
        if (this.userService.checkIsTeleCallerOffline()) {
            const { payObj } = postBody;
            // todo if user is offline
            return this.dexieService.setPhoneLogOutbox().add(
                {
                    file,
                    isOffline: true,
                    type: 'phone',
                    loggedInUserId: this.userService.getLoggedInUserId(),
                    url: endPoint,
                    postData: JSON.stringify(postBody),
                    paymentObj: payObj ? JSON.stringify(payObj) : null
                }).then(() =>
                    Promise.resolve({
                        resultShort: 'offline',
                        resultLong:
                            'You are offline. Synchronize the added comment when you get back online'
                    })
                    // tslint:disable-next-line: no-console
                ).catch((error: any) => console.log(error))
        }
        // if user is online
        // this.createCustomerDetails(endPoint, formData).then(response => {

        // })
        return this.http.post(endPoint, formData).toPromise();
    }

  updateCommuncationDetailsAfterCall(postObj: any, file: any) {
    const formData: FormData = new FormData();
    if (file) {
      formData.append("file", file, file.name);
    }
    formData.append("communicationData", JSON.stringify(postObj));
    return this.http.post(
      this.globalSettings.getApiUrl() +
        "/api/timeline3/updateCommuncationDetailsAfterCall",
      formData
    );
  }

    createCustomerDetails(endPoint: any, formData: any): Promise<any> {
        return this.http.post(endPoint, formData).toPromise();
    }

    saveCustomerResponse(postObj: any): Observable<any> {
        return this.http
            .post(
                this.globalSettings.getApiUrl() +
                "/api/communicationManager/customerResponsePhoneLog",
                postObj
            )
            .pipe(catchError((e: any) => this.userService.getCheckError(e)));
    }


    requestCloseAPI(queryObj: any): Observable<any> {
        return this.http
            .post(
                this.globalSettings.getApiUrl() + "/api/timeline3/closeAPICall",
                queryObj
            )
            .pipe(catchError((e: any) => this.userService.getCheckError(e)));
    }
}
